import React from 'react'
// @src imports
import { Address, Blinker, Button } from 'src/chrome'
import { AddressForm } from 'src/contacts/components'
import { AddressFragment } from 'src/graphql'
import { useState } from 'src/hooks'

import tileStyles from 'src/chrome/styles/detailView.module.scss'

import styles from './returnAddress.module.scss'
import { OrderWithPartialLines } from 'src/redux/reducers/orders'
import { Text } from '@sendoutcards/quantum-design-ui'

interface ReturnAddressProps {
  shouldBlink: boolean
  onSave: (address: AddressFragment) => void
  order: OrderWithPartialLines
  toggleAddressBlinker: () => void
}

const ReturnAddress: React.FC<ReturnAddressProps> = props => {
  const { shouldBlink, onSave, order, toggleAddressBlinker } = props

  const [isEditing, setIsEditing] = useState(
    !order.returnAddress || !order.returnAddress.address1,
  )

  const [address, setAddress] = useState(
    order.returnAddress || {
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      company: '',
      city: '',
      state: '',
      country: 'United States',
      postalCode: '',
    },
  )

  const handleChange: React.ReactEventHandler<HTMLInputElement> = event => {
    setAddress({
      ...address,
      [event.currentTarget.name]: event.currentTarget.value,
    })
  }

  const handleCountryChange = (country: string) => {
    setAddress({
      ...address,
      country: country,
    })
  }

  const handleStateChange = (state: string) => {
    setAddress({
      ...address,
      state: state,
    })
  }

  const handleSave = () => {
    onSave(address)
    setIsEditing(false)
  }

  const blinkHelper = shouldBlink ? (
    <Blinker
      style={{ bottom: 7 }}
      messagePosition={{
        position: 'absolute',
        top: -95,
        right: 85,
      }}
      message={'Please make sure you have a return address'}
    />
  ) : null
  const editAddress = isEditing ? (
    <AddressForm
      toggleAddressBlinker={toggleAddressBlinker}
      contact={address}
      onChange={handleChange}
      onCountryChange={handleCountryChange}
      onStateChange={handleStateChange}
      shouldShowDates={false}
      isTitleVisible={false}
      onSubmit={handleSave}
    />
  ) : (
    <Address address={address} />
  )
  return (
    <section
      className={`${tileStyles.previewSection} ${tileStyles.overviewCard}`}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <Text type="largeBody" color="primaryHeading">
            Return Address
          </Text>
          {blinkHelper}
          {!order.isSent && (
            <div className={styles.actions}>
              <Button
                title={isEditing ? 'Cancel' : 'Edit'}
                style={{ marginRight: 15 }}
                onClick={() => {
                  setIsEditing(e => !e)
                }}
                id={'edit_or_cancel_return_address_btn'}
              />
            </div>
          )}
        </div>
        {editAddress}
      </div>
    </section>
  )
}

export default ReturnAddress
